import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { user, customerLogin } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/shop" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await customerLogin(form.email, form.password);
    setLoading(false);
    if (res.ok) { toast.success("¡Bienvenido!"); navigate("/shop"); }
    else toast.error(res.error || "Error al iniciar sesión");
  };

  return (
    <div className="min-h-[calc(100vh-120px)] flex items-center justify-center px-4 py-12 hero-pattern" data-testid="customer-login-page">
      <div className="bg-white rounded-3xl border border-slate-200 shadow-xl w-full max-w-md p-8">
        <div className="flex justify-center"><Logo size="md" /></div>
        <div className="mt-8 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-green-50 rounded-full mb-3">
            <LogIn className="w-5 h-5 text-green-600" />
          </div>
          <h1 className="font-heading text-2xl font-bold">Iniciar sesión</h1>
          <p className="text-sm text-slate-500 mt-1">Ingresá para ver precios y hacer tu pedido</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">Email</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-1 w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none" data-testid="login-email" />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">Contraseña</label>
            <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1 w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none" data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white rounded-full px-6 py-3 font-semibold transition-colors disabled:bg-slate-300" data-testid="login-submit">
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
        <p className="text-sm text-slate-600 text-center mt-5">
          ¿No tenés cuenta? <Link to="/register" className="text-blue-600 hover:text-blue-800 font-semibold" data-testid="goto-register">Registrate gratis</Link>
        </p>
        <p className="text-xs text-slate-400 text-center mt-2">
          ¿Sos administrador? <Link to="/admin/login" className="hover:text-blue-600">Acceso admin</Link>
        </p>
      </div>
    </div>
  );
}
